export default __webpack_public_path__ + "static/media/InsideEyes_09.40319e6e.png";